import { Action, createReducer, on } from '@ngrx/store';
import * as downloadActions from '../actions/download.actions';

export const downloadFeatureKey = 'download';

export interface State {
    managementDownloading?: boolean;
    legalDownloading?: boolean;
    locationDownloading?: boolean;
    translationDownloading?: boolean;
}

export const initialState: State = {};

const downloadReducer = createReducer(
    initialState,
    on(downloadActions.downloadManagementInformation, (state) => ({
        ...state,
        managementDownloading: true
    })),
    on(downloadActions.downloadManagementInformationSuccess, (state) => ({
        ...state,
        managementDownloading: false
    })),
    on(downloadActions.downloadLegalInformation, (state) => ({
        ...state,
        legalDownloading: true
    })),
    on(downloadActions.downloadLegalInformationSuccess, (state) => ({
        ...state,
        legalDownloading: false
    })),
    on(downloadActions.downloadLocationInformation, (state) => ({
        ...state,
        locationDownloading: true
    })),
    on(downloadActions.downloadLocationInformationSuccess, (state) => ({
        ...state,
        locationDownloading: false
    })),
    on(downloadActions.downloadTranslationInformation, (state) => ({
        ...state,
        translationDownloading: true
    })),
    on(downloadActions.downloadTranslationInformationSuccess, (state) => ({
        ...state,
        translationDownloading: false
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return downloadReducer(state, action);
}
